export default __webpack_public_path__ + "7b9ef4ba4c1d65f7037b68c43e00752f.png";